import React, { Suspense, lazy } from "react";

import { Switch, Route, Redirect } from "react-router-dom";
import { observer } from "mobx-react-lite";

import FallBackLoading from "../FallBackLoading";
import Loading from "../../components/Loading";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import { useStores } from "../../stores/RootStore";
import { PrivateRoute } from "../../components/PrivateRoute";

const AsyncLogin = lazy(() => import("../Login"));
const AsyncRegister = lazy(() => import("../Register"));
const AsyncForgotPassword = lazy(() => import("../ForgotPassword"));
const AsyncForgotPasswordStep2 = lazy(() => import("../ForgotPasswordStep2"));
const AsyncDashboard = lazy(() => import("../Dashboard"));
const AsyncNotFound = lazy(() => import("../NotFound"));

function redirectTo(path: string) {
	return <Redirect to={path} />;
}

function App() {
	const { generalStore, authStore } = useStores();

	const redirectFromRoot = () => {
		return redirectTo("/dashboard");
	};

	const redirectTo404 = () => {
		return redirectTo("/404");
	};

	return (
		<>
			<Loading show={generalStore.showLoading} />
			{!!generalStore.snackbar && (
				<Snackbar
					open={!!generalStore.snackbar}
					autoHideDuration={6000}
					onClose={generalStore.closeSnackbar}
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
				>
					<Alert
						elevation={6}
						variant="filled"
						onClose={generalStore.closeSnackbar}
						severity={generalStore.snackbar!.variant}
					>
						{generalStore.snackbar!.msg}
					</Alert>
				</Snackbar>
			)}
			<Suspense fallback={<FallBackLoading />}>
				<Switch>
					<Route exact path="/" render={redirectFromRoot} />
					<PrivateRoute
						isAuthPage={false}
						redirectTo="/dashboard"
						isAuthenticated={authStore.isAuthenticated}
						exact
						path="/login"
						component={AsyncLogin}
					/>
					<PrivateRoute
						isAuthPage={false}
						redirectTo="/dashboard"
						isAuthenticated={authStore.isAuthenticated}
						exact
						path="/register"
						component={AsyncRegister}
					/>
					<PrivateRoute
						isAuthPage={false}
						redirectTo="/dashboard"
						isAuthenticated={authStore.isAuthenticated}
						exact
						path="/forgotPassword"
						component={AsyncForgotPassword}
					/>
					<PrivateRoute
						isAuthPage={false}
						redirectTo="/dashboard"
						isAuthenticated={authStore.isAuthenticated}
						exact
						path="/forgotPassword/:token"
						component={AsyncForgotPasswordStep2}
					/>
					<PrivateRoute
						isAuthPage={true}
						redirectTo="/login"
						isAuthenticated={authStore.isAuthenticated}
						path="/dashboard"
						component={AsyncDashboard}
					/>
					<Route exact path="/404" component={AsyncNotFound} />
					<Route path="/" render={redirectTo404} />
				</Switch>
			</Suspense>
		</>
	);
}

export default observer(App);
